import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export abstract class AUserPermissionsService {
  abstract get hasFullControl$(): Observable<boolean>;
  abstract get isAdmin$(): Observable<boolean>;
  abstract get hasLimitedAccess$(): Observable<boolean>;
  abstract get isCustomerAgent$(): Observable<boolean>;
}
